module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag03_0117AT.fcc2688d.jpg";